import React from 'react';
export const MediaRenderContext = React.createContext();